import {type RevaLanguage, selectByLanguage} from "@reva/shared/i18n";
import {formatMarketAndLendingValue} from "@reva/shared/number-format";

import type {ValueInfoSpec} from "../redux/specSelectors";
import type {IndicationValueAndLendingValueData} from "./valueIndicationUtil";

const INTL_DE_VALUE_NO_LIMIT = new Intl.NumberFormat("de-DE", {
    maximumFractionDigits: 6,
});
const INTL_EN_VALUE_NO_LIMIT = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 6,
});

/**
 * Format Latitude or Longitude value.
 * @param value the value to format
 * @param language optional language identifier
 * @return formatted String
 */
export function formatLatLon(value: number, language?: RevaLanguage): string {
    if (typeof value !== "number") return "";
    const nf = selectByLanguage(language, INTL_DE_VALUE_NO_LIMIT, INTL_EN_VALUE_NO_LIMIT);
    return nf.format(value);
}

/**
 * Format value without rounding and with grouping.
 * @param value the value to format
 * @param language language identifier
 * @return formatted String
 */
export function formatNonRoundedValue(value: number, language: RevaLanguage): string {
    if (typeof value !== "number") return "";
    const fmt = new Intl.NumberFormat(language, {
        useGrouping: true,
        maximumFractionDigits: 10,
    });
    return fmt.format(value);
}

export function formatValueInfo(
    valueAndLendingValue: IndicationValueAndLendingValueData | null,
    valueSpec: ValueInfoSpec | null,
    language: RevaLanguage,
) {
    if (!valueAndLendingValue || !valueSpec) return {};

    const {value, valueSqm, valueLending, valueLendingSqm} = formatMarketAndLendingValue(
        valueAndLendingValue,
        valueSpec,
        language,
    );
    return {
        value,
        valueSqm,
        valueLending,
        valueLendingSqm,
        indicationNameDe: valueAndLendingValue?.indicationNameDe,
        indicationNameEn: valueAndLendingValue?.indicationNameEn,
    };
}
